export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-display text-xl font-medium tracking-tight mb-3">
            14<span className="text-zinc-500">/</span>Brandscaling
          </div>
          <p className="text-sm text-zinc-500 max-w-xs">
            A 14-day operator's program to launch and scale a premium personal
            brand with paying clients.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Program</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><a href="#curriculum" className="hover:text-white transition">Curriculum</a></li>
            <li><a href="#pricing" className="hover:text-white transition">Pricing</a></li>
            <li><a href="#faq" className="hover:text-white transition">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Company</div>
          <p className="text-sm text-zinc-500">
            © {new Date().getFullYear()} Brandscaling Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
